import type { ComponentProps, FC, ReactNode } from 'react'

import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'
import { controlClasses } from '@/components/ui/input'

type SelectProps = ComponentProps<'select'> & {
    wrapperClassName?: string
}

export const Select: FC<SelectProps> = ({ className, wrapperClassName, children, ...props }): ReactNode => {
    return (
        <div className={cn('relative min-w-0', wrapperClassName)}>
            <select
                className={cn(controlClasses, 'h-10 cursor-pointer appearance-none truncate pr-9 pl-3', className)}
                {...props}
            >
                {children}
            </select>

            <ChevronDown
                className='pointer-events-none absolute top-1/2 right-3 size-4 -translate-y-1/2 text-muted-foreground'
                aria-hidden='true'
            />
        </div>
    )
}
